import { ExpandableSection, SubSection, InfoCardSection } from "./components";
import { charts, infoCardContent } from "../constants";
import { ChartProvider, useCurrentSelection } from "../../../../contexts";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export default function Panel({ openModal }) {
  const { currentSelection } = useCurrentSelection();

  return (
    <div
      id="jmrvPanel"
      className="z-20 w-full"
      style={{ scrollbarGutter: "stable" }}
    >
      {currentSelection.chartData ? (
        <>
          <InfoCardSection>
            <p>{infoCardContent.lastUpdated}</p>
            <p>{infoCardContent.note}</p>
          </InfoCardSection>

          {charts.map((chart) => {
            const subSectionProps = {
              description: chart.description,
              breakdownTitle: chart.breakdownTitle,
              breakdownSubtitle: chart.breakdownSubtitle,
              colors: chart.colors,
              category: chart.category,
            };

            return (
              <ExpandableSection
                key={chart.title}
                title={chart.title}
                openModal={openModal}
                modalContent={chart.modalContent}
              >
                <ChartProvider product={chart.category} type={chart.chartType}>
                  <SubSection {...subSectionProps} />
                </ChartProvider>
              </ExpandableSection>
            );
          })}
        </>
      ) : (
        <SkeletonTheme color="#e0e0e0" highlightColor="#c0c0c0">
          <Skeleton width={410} height={60} count={4} className="mb-2" />
        </SkeletonTheme>
      )}
    </div>
  );
}
